import SelectInput from '../inputs/SelectInput';

export const settingsConfig = {
  priceUpdateMode: {
    label: 'Price Update Mode',
    component: SelectInput,
    options: [
      {
        label: 'Automatic',
        value: 'automatic',
      },
      {
        label: 'Scheduled',
        value: 'Scheduled',
      },
      {
        label: 'Manual',
        value: 'manual',
      },
    ],
  },
};
